import { useCallback, useEffect, useRef, useState } from "react";
import { RefreshCw, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api } from "@/lib/api";

export const useCaptcha = (kind) => {
  const [data, setData] = useState(null);
  const [answer, setAnswer] = useState("");
  const seq = useRef(0);
  const reload = useCallback(() => {
    setAnswer("");
    const n = ++seq.current;
    api.get("/captcha", { params: { kind } }).then((r) => { if (n === seq.current) setData(r.data); }).catch(() => { if (n === seq.current) setData(null); });
  }, [kind]);
  useEffect(() => { reload(); }, [reload]);
  return { kind, data, answer, setAnswer, reload, fields: { captcha_id: data?.id || "", captcha_answer: answer } };
};

export const CaptchaField = ({ c, testId = "captcha" }) => (
  <div className="rounded-md border border-[#E5E7EB] bg-[#F8F9FA] p-3" data-testid={`${testId}-box`}>
    <div className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-gray-600">
      <ShieldCheck className="w-3.5 h-3.5 text-[#E60000]" /> Security check
    </div>
    <div className="mt-2 flex flex-wrap items-center gap-2">
      {c.kind === "math" ? (
        <div className="h-11 px-4 rounded-md bg-white border border-[#E5E7EB] font-mono text-lg font-bold grid place-items-center" data-testid={`${testId}-question`}>
          {c.data ? `${c.data.question} =` : "…"}
        </div>
      ) : (
        <div className="h-[60px] w-[180px] rounded-md bg-white border border-[#E5E7EB] overflow-hidden grid place-items-center">
          {c.data ? <img src={c.data.image} alt="Type the characters shown" className="h-full w-full object-cover select-none" draggable={false} data-testid={`${testId}-image`} /> : <span className="text-gray-400 text-sm">Loading…</span>}
        </div>
      )}
      <button type="button" onClick={c.reload} title="Get a new one" aria-label="Get a new security check" className="w-10 h-10 grid place-items-center rounded-md border border-[#E5E7EB] bg-white hover:text-[#E60000] transition-colors" data-testid={`${testId}-refresh`}>
        <RefreshCw className="w-4 h-4" />
      </button>
      <Input value={c.answer} onChange={(e) => c.setAnswer(e.target.value)} inputMode={c.kind === "math" ? "numeric" : "text"} autoComplete="off" autoCapitalize="characters"
        placeholder={c.kind === "math" ? "Answer" : "Type the characters"} className="h-11 flex-1 min-w-[120px] bg-white" required data-testid={`${testId}-input`} />
    </div>
  </div>
);
